{
  "el": {
    "levels": {
      "actions": {
        "add_customer": "Προσθήκη πελάτη",
        "cancel": "Αναίρεση",
        "changeLevel": "Αλλαγή επιπέδου",
        "changeTargetGroup": "Αλλαγή ομάδας-στόχου",
        "delete": "Διαγραφή",
        "removeCustomer": "Αφαίρεση πελάτη",
        "requestUnits": "Αίτημα για ακίνητα",
        "save": "Αποθήκευση"
      },
      "building": "Κτίριο",
      "customers": "Πελάτες",
      "descriptions": {
        "mupCantDelete": "Φαίνεται ότι υπάρχουν ακόμη ακίνητα μέσα σε αυτό το έργο. Για να διαγράψεις το έργο, σου προτείνουμε να διαγράψεις πρώτα τα ακίνητα. Έτσι είμαστε 100% σίγουροι ότι το έργο μπορεί να διαγραφεί.",
        "mupCantDeleteDeactivate": "Εναλλακτικά, αντί να διαγράψεις το έργο, μπορείς να το απενεργοποιήσεις. Έτσι όλες οι πληροφορίες διατηρούνται για μελλοντική χρήση. Θέλεις να απενεργοποιήσεις αυτό το έργο;"
      },
      "labels": {
        "activity": "Ιστορικό",
        "aftercare": "Παρατηρήσεις",
        "allLevels": "Όλα τα επίπεδα",
        "contacts": "Επαφές",
        "conversations": "Συνομιλίες",
        "decisions": "Αποφάσεις",
        "deleteProject": "Θέλεις σίγουρα να διαγράψεις {project_name};",
        "deleteProjectDisclaimer": "Η διαγραφή αυτού του έργου θα οδηγήσει σε οριστική απώλεια όλων των δεδομένων και του περιεχομένου. Η ενέργεια είναι μη αναστρέψιμη. Εναλλακτικά, σκέψου να απενεργοποιήσεις το έργο ώστε να διατηρηθούν όλες οι πληροφορίες για μελλοντική χρήση. Προχώρα με προσοχή.",
        "deleteWarning": "Προσοχή. Η διαγραφή αυτού του επιπέδου θα διαγράψει όλα τα υποκείμενα επίπεδα, τα έγγραφα, τις ανακοινώσεις, τις ερωτήσεις FAQ και τις εργασίες που σχετίζονται με αυτό το επίπεδο.",
        "documents": "Έγγραφα",
        "download": "Λήψη {level_name}",
        "generatingExport": "Δημιουργία εξαγωγής...",
        "hide": "Απόκρυψη",
        "information": "Πληροφορίες",
        "installment": "Οικονομικά",
        "milestones": "Ορόσημα",
        "multiple_selection": "Πολλαπλή επιλογή",
        "mupCantDelete": "Αυτή η ενέργεια δεν είναι δυνατή",
        "needMoreUnits": "Χρειάζεσαι περισσότερα ακίνητα;",
        "reachedMax": "Δημιούργησες το ακίνητο που έχει ανατεθεί σε αυτό το έργο. | Έφτασες τα {count} ακίνητα που έχουν ανατεθεί σε αυτό το έργο.",
        "reachedMaxRundle": "Έφτασες το όριό σου του 1 ενεργού ακινήτου. | Έφτασες το όριό σου των {count} ενεργών ακινήτων.",
        "requestMoreUnits": "Επικοινώνησε με την ομάδα της Ziggu αν θέλεις να ζητήσεις περισσότερα ενεργά ακίνητα.",
        "settings": "Ρυθμίσεις έργου",
        "sharedWith": "Κοινοποιήθηκε σε ",
        "showForLevel": "Εμφάνιση {object} για το επίπεδο",
        "spaces": "Βοηθητικοί χώροι",
        "surveys": "Ερωτηματολόγια",
        "tickets": "Συνομιλίες",
        "todos": "Εργασίες",
        "todos_v2": "Εργασίες v2",
        "willBeAssigned": "Διαθέσιμο για όλους σε",
        "willBePublished": "Θα εμφανιστεί σε όλους σε",
        "willBeUploaded": "Θα ανέβει σε"
      },
      "lot": "Οικόπεδο",
      "phase": "Φάση",
      "project": "Έργο",
      "tooltip": {
        "add_level": "Προσθήκη {level}"
      },
      "unit": "Ακίνητο"
    }
  }
}
